/**
 * ScrollToTop.tsx - Scroll automatico ad inizio pagina al cambio route
 * 
 * Garantisce che l'utente parta dall'inizio quando naviga a una nuova pagina.
 * La navigazione con tasto Indietro/Avanti del browser mantiene la posizione
 * precedente grazie al scroll restoration nativo.
 */

import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Solo per navigazione PUSH (link, navigate), non POP (tasto indietro/avanti)
    if (navigationType !== "POP") {
      window.scrollTo({ top: 0, left: 0 });
    }
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
